import { LocalStorageKeys } from "@/common/browserStorage/constants";
import { getStorageValue } from "@/common/browserStorage/utils";
import {
  LOAN_AMOUNT_INITIAL_VALUE,
  LOAN_PERIOD_INITIAL_VALUE,
} from "@/common/constants/loan";
import { LoanValuesProps } from "@/entities/loan/model/types";
import { DEFAULT_LOCALE } from "@/lang/types";

export function initLocalStorage() {
  try {
    getStorageValue(LocalStorageKeys.Locale, DEFAULT_LOCALE);

    const fallbackLoanValues: LoanValuesProps = {
      amount: LOAN_AMOUNT_INITIAL_VALUE,
      period: LOAN_PERIOD_INITIAL_VALUE,
    };
    getStorageValue(LocalStorageKeys.LoanValues, fallbackLoanValues);
  } catch (error) {
    throw Error(JSON.stringify(error));
  }
}
